import env from '~env';
import { HttpLoggerConfig } from './types';

export const defaultHttpLoggerConfig: Partial<HttpLoggerConfig> = {
  endpoint: `${env.apiUrls.restV2}/v1/telemetry/logs`,
  batchSize: 500,
  flushInterval: 10,
  maxRetries: 5,
  retryBackoffFactor: 2,
  maxPayloadSize: 500,
};
